define('common/ko/extension/toggleable',['knockout'], function (ko) {
    ko.extenders.toggleable = function(bool, conf) {
        bool.toggle = function() {
            bool(!bool());
        };

        return bool;
    };
});

